module.exports = __webpack_public_path__ + "static/media/loading.2825e6e2.gif";